require('./RAPieChart.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { PieChart, Pie, Legend, Tooltip } = require('recharts');
// @ utilities
const { formatPercentage } = require('utilities/RACurrencyHelper');
// @ constants
const { PERCENTAGE_SYMBOL, SECONDARY_BAR_COLOR } = require('constants/RAConstants');

class RAPieChart extends React.Component {
    buildBorderShadow() {
        return <div className="ra-pie-chart__inner-shadow" />;
    }

    buildLegend() {
        const borderShadow = this.buildBorderShadow();

        return (
            <Legend
                content={borderShadow}
                layout="vertical"
                verticalAlign="middle"
                wrapperStyle={{
                    border: 'none',
                    background: 'transparent',
                    width: '100%',
                    height: '100%',
                }}
            />
        );
    }

    buildTooltipContent(data) {
        if (data.payload.length > 0) {
            const percentage = `${formatPercentage(data.payload[0].value, false)} ${PERCENTAGE_SYMBOL}`;

            return (
                <div className="ra-portfolio-donut__tooltip hidden-xs">
                    <div className="ra-portfolio-donut__tooltip-text">{data.payload[0].name}</div>
                    <div>{percentage}</div>
                </div>
            );
        }
    }

    buildTooltip() {
        return (
            <Tooltip
                active={true}
                content={this.buildTooltipContent}
                position={{ x: 0, y: 0 }}
                wrapperStyle={{
                    border: 'none',
                    background: 'transparent',
                    width: '100%',
                    height: '100%',
                }}
            />
        );
    }

    render() {
        const { data, width, height, innerRadius, outerRadius } = this.props;
        let dataSet;
        let extraProps;
        let legend;
        let stroke;
        let tooltip;

        if (data && (data.length > 0 || data.size > 0)) {
            dataSet = data.toJS ? data.toJS() : data;
            stroke = 'none';
            tooltip = this.buildTooltip();
        } else {
            dataSet = [
                { name: '', value: 50 },
                { name: '', value: 50 },
            ];
            extraProps = {
                fill: '#405cd6',
                startAngle: 90,
                endAngle: 450,
                strokeWidth: '2px',
            };
            stroke = SECONDARY_BAR_COLOR;
            legend = this.buildLegend();
        }

        return (
            <div className="ra-pie-chart">
                <PieChart width={width} height={height}>
                    <Pie
                        data={dataSet}
                        endAngle={-360}
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        paddingAngle={-1}
                        startAngle={90}
                        stroke={stroke}
                        dataKey="value"
                        {...extraProps}
                    />
                    {legend}
                    {tooltip}
                </PieChart>
            </div>
        );
    }
}

RAPieChart.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    height: PropTypes.number,
    innerRadius: PropTypes.number,
    outerRadius: PropTypes.number,
    width: PropTypes.number,
};

RAPieChart.defaultProps = {
    height: 180,
    innerRadius: 54,
    modifier: 'primary',
    outerRadius: 86,
    width: 180,
};
module.exports = RAPieChart;
